export const changedCellStyle = {
	boxShadow: "0px 0px 100px rgba(255,0,0,0.5) inset",
};

const arraysEqual = (a, b) => {
	if (!Array.isArray(a) || !Array.isArray(b)) return false;
	if (a.length !== b.length) return false;
	return a.every((val, index) => val === b[index]);
};

const defaultIsEqual = (a, b) => {
	if (Array.isArray(a) && Array.isArray(b)) return arraysEqual(a, b);
	return a === b;
};

export const createCellStyle = (data, nextForRecordId, excludeFields = [], isEqual = defaultIsEqual) =>
	(fieldName, record) => {
		if (!data || excludeFields.includes(fieldName)) return;
		if (!record) return;
		const nextRecordId = nextForRecordId?.[record.id];
		if (!nextRecordId) return;
		if (!isEqual(data[nextRecordId]?.[fieldName], record[fieldName])) return changedCellStyle;
	};
